/* RunScreenRenderer.js */

"use strict";
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const InputTextControl = require("@gluenetworks/steve_ui_core").Control.Textfield.InputText;
const _ = require("lodash");

class RunScreenRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("run-screen-gl");
        this._rootElem.component = this._model;
        this._logger = this._model.logger;

        this._titleText = document.createElement("h3");
        this._titleText.innerHTML = "Run OS Plan";

        let _osPlanTitle = "";

        if (!_.isEmpty(this._model._gameEditor.getPlan().getId())) {
            const osPlanEntities = this._model._gameEditor.getPlan();
            _osPlanTitle = "OS Plan " + osPlanEntities.getName();
        }

        this._planTitleInput = new InputTextControl({
            darkTheme: true,
            value: _osPlanTitle
        });

        this._buttonBarElem = document.createElement("button-container");
        this._buttonBarElem.classList.add("button-bar");

        this._schedulePlan = new ButtonControl({
            label: "Schedule OS Plan",
            darkTheme: true
        });
        this._startPlan = new ButtonControl({
            label: "Run",
            active: true
        });
        this._cancelButton = new ButtonControl({
            label: "Cancel",
            darkTheme: true
        });
        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._schedulePlan.on("UserClick", this._schedulePlanAction.bind(this));
        this._startPlan.on("UserClick", this._startPlanAction.bind(this));
        this._cancelButton.on("UserClick", this._cancelAction.bind(this));
    }

    _unregisterListeners() {
        this._schedulePlan.removeListener("UserClick", this._schedulePlanAction);
        this._startPlan.removeListener("UserClick", this._startPlanAction);
        this._cancelButton.removeListener("UserClick", this._cancelAction);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();

        let promArr = [this._planTitleInput.shutdown(), this._schedulePlan.shutdown(), this._startPlan.shutdown(), this._cancelButton.shutdown()];

        return Promise.all(promArr).then(
            () => {
                this._titleText.remove();
                this._titleText = undefined;
                this._planTitleInput = undefined;
                this._buttonBarElem.remove();
                this._schedulePlan = undefined;
                this._startPlan = undefined;
                this._cancelButton = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
            },
            (err) => {
                this._logger.warn({ error: err }, "RunScreenRenderer.shutdown() error.");
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve) => {
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._titleText);
                this._rootElem.appendChild(this._planTitleInput.renderer.rootElement);
                this._buttonBarElem.appendChild(this._cancelButton.renderer.rootElement);
                this._buttonBarElem.appendChild(this._schedulePlan.renderer.rootElement);
                this._buttonBarElem.appendChild(this._startPlan.renderer.rootElement);
                this._rootElem.appendChild(this._buttonBarElem);
            }
            resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/
    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _schedulePlanAction() {
        const workInput = this._getWorkInput();
        return this._model.schedulePlan(workInput);
    }

    _startPlanAction() {
        const workInput = this._getWorkInput();
        this._model.startPlan(workInput);
    }

    _getWorkInput() {
        return {
            description: this._planTitleInput.value
                ? this._planTitleInput.value
                : "Run OS Plan - " + new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString()
        };
    }
    _cancelAction() {
        this._model.cancelRun();
    }
    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = RunScreenRenderer;
